import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import getAppConfig from 'app-config';
import PropTypes from 'prop-types';
import styles from '../style/StudentPin.module.scss';

const t = (key) => translate('common', key);

export const ClearPinBtn = ({ contentScaling, onClick }) => {
  const clearPinBtn = useSelector((state) => getAppConfig(state.login.app).buttons.clearPin);

  return (
    <button
      className={['login-button', styles.button, styles[`button${contentScaling}`]].join(' ')}
      style={{ color: clearPinBtn?.textColor }}
      onClick={onClick}
    >
      {t('ClearSecretCode')}
    </button>
  );
};

ClearPinBtn.propTypes = {
  contentScaling: PropTypes.number,
  onClick: PropTypes.func
};

export default ClearPinBtn;
